import { Theme } from './theme';

export function getDropdownStyles(theme: Theme) {
	const { border, boxShadow, borderRadius, padding, gap } = theme.dropdown.button;
	const css = {
		dropDownButton_css: {
			border: border,
			'box-shadow': boxShadow,
			'border-radius': borderRadius,
			padding: padding,
			gap: gap
		},
		dropDownOpen_css: {
			'box-shadow': theme.dropdown.open.boxShadow
		},
		dropDownContent_css: {
			width: theme.dropdown.content.width,
			'border-radius': theme.dropdown.content.borderRadius,
			border: theme.dropdown.content.border,
			'box-shadow': theme.dropdown.content.boxShadow,
			'margin-top': theme.dropdown.content.marginTop
		}
	};
	return css;
}
